export default __webpack_public_path__ + "static/media/pageone.cf1071c4.txt";